import PropTypes from 'prop-types';
import { SITE_NAME } from '../config/site';

/**
 * Placeholder mark. Branding is parked — this is a neutral geometric glyph
 * (an arena ring with a player dot), not a brand decision.
 */
function Logo({ size = 32, className = '' }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label={`${SITE_NAME} logo`}
    >
      <rect width="32" height="32" rx="8" fill="#0D1B2A" />
      <circle
        cx="16"
        cy="16"
        r="8"
        stroke="#D4A24C"
        strokeWidth="2.5"
        fill="none"
      />
      <circle cx="16" cy="16" r="3" fill="#D4A24C" />
    </svg>
  );
}

Logo.propTypes = {
  size: PropTypes.number,
  className: PropTypes.string,
};

Logo.defaultProps = {
  size: 32,
  className: '',
};

export default Logo;
